// src/components/Assets/Templates/Normal1/normal1.js
export default `
  <!DOCTYPE html>
<html lang="en" dir="ltr" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<meta charset="utf-8">
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<meta name="viewport" content="width=device-width,initial-scale=1">
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no">
<meta name="x-apple-disable-message-reformatting">
<meta name="color-scheme" content="light dark">
<meta name="supported-color-schemes" content="light dark">
<title>Email Template</title>
<!--	Outlook DPI Code Start -->
<!--[if mso]>
<noscript>
<xml>
<o:OfficeDocumentSettings>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml>
</noscript>
<style>
table { border-collapse: collapse; mso-table-lspace: 0px; mso-table-rspace: 0px; }
tr {font-size:0px;line-height:0px;}
sup { font-size:66%;line-height:100%;mso-text-raise: 0%;}
li {margin-left:-23px !important}

//Use only when using a non-websafe font
body { margin: 0 !important; padding: 0 !important; font-family: Helvetica, sans-serif !important;}
body, table, td, a, span, p, h1, h2, h3, h4 { font-family: Helvetica, sans-serif !important;} 
</style>
<![endif]-->

<!--	Outlook DPI Code End -->

<style>
* a {color:#ffffff; text-decoration: none;}
:root {
color-scheme: light dark;
supported-color-schemes: light dark;
}
/* Fix for Outlook links color fix for links and visited links */
span.MsoHyperlink {color: inherit !important; mso-style-priority: 99 !important; text-decoration: underline !important;}

span.MsoHyperlinkFollowed {color: inherit !important; mso-style-priority: 99 !important;}
/* normalise link attributes in Outlook app iOS/Android - to match the parent element */
body[data-outlook-cycle] a {color: inherit !important; text-decoration: none !important;}
/* normalise link attributes in Apple Mail / iOS Mail apps - to match the parent element */
a[x-apple-data-detectors] {color: inherit!important; text-decoration: none!important; font-size: inherit!important; font-family: inherit!important; font-weight: inherit!important; line-height: inherit!important;}
#root [x-apple-data-detectors=true],a[x-apple-data-detectors=true]{
color: inherit !important; text-decoration: inherit !important;}
#main #inner a[x-apple-data-detectors]{color: inherit !important;
text-decoration: inherit !important;}
a[href^=tel], #MessageViewBody a, a[x-apple-data-detectors], #body a, .link {color: inherit; text-decoration: none; font-size: inherit;
font-family: inherit; font-weight: inherit; line-height: inherit;}
[data-outlook-cycle] [x-apple-data-detectors-type="calendar-event"] {color: inherit !important;-webkit-text-decoration-color: inherit !important; text-decoration: none !important;}
/* normalise link attributes in Gmail - to match the parent element */
u + #body a {color: inherit; text-decoration: none; font-size: inherit; font-weight: inherit; line-height: inherit;}
#preheader,#preview-spacer {display: none; display: none!important;}
ul{padding-left: 17px !important;}
ol{padding-left: 17px !important;}
hr{margin: 0 !important;}
input{display: none!important;}
u ~ div img + div > div  {display: none;}
/*Mobile CSS*/
@media only screen and (max-width: 639px){
.textCenter{text-align: center!important;}
.font12{font-size: 10px!important; line-height: 16px!important;}
.pt10{padding-top: 10px!important;}
.pt55{padding-top: 55px!important;}
.pt20{padding-top: 20px!important;}
.pt35{padding-top: 35px!important;}
.pb15{padding-bottom: 15px!important;}
.pb20{padding-bottom: 20px!important;}
.pb25{padding-bottom: 25px!important;}
.mobile-hide{display: none!important;}
.mobile-show{display: block!important;}
.w90{width: 90%!important;}
.w80{width: 88%!important;}
.w75{width: 75%!important;}
.w60{width: 60%!important;} 
.w320{width: 320px !important;} 
.w100{width: 100%!important; min-width: 100%!important; max-width: 1000px!important; height: auto!important;}
.table{display: table !important; width: 100% !important;}
.display-footer{display: table-footer-group!important; width: 100%!important; min-width: 100%!important;}
.display-header{display: table-header-group!important; width: 50%!important; min-width: 100%!important;}
.drop{width: 100%!important; float: left!important; display: block!important;}
.bg_img1{background-image: url('https://ik.imagekit.io/sriHari143/templates/n1/bg-img1-mob_yvq0YFfXt.jpg?updatedAt=1742461175289') !important; background-position: left top !important; background-size: cover !important; height: auto !important; background-repeat:no-repeat !important; }
.bg_img1{background: url(https://ik.imagekit.io/sriHari143/templates/n1/bg-img1-mob_yvq0YFfXt.jpg?updatedAt=1742461175289) left top / cover no-repeat !important; height: auto !important;}
.bg_img2{background-image: url('https://ik.imagekit.io/sriHari143/templates/n1/bg-img2-mob_bvJGmVHA4.jpg?updatedAt=1742461175426') !important; background-position: left top !important; background-size: cover !important; height: auto !important; background-repeat:no-repeat !important; }
.bg_img2{background: url(https://ik.imagekit.io/sriHari143/templates/n1/bg-img2-mob_bvJGmVHA4.jpg?updatedAt=1742461175426) left top / cover no-repeat !important; height: auto !important;}
.bg_img3{background-image: url('https://ik.imagekit.io/sriHari143/templates/n1/bg-img3-mob_SHCOV1Hrs.jpg?updatedAt=1742461167966') !important; background-position: left top !important; background-size: cover !important; height: auto !important; background-repeat:no-repeat !important; }
.bg_img3{background: url(https://ik.imagekit.io/sriHari143/templates/n1/bg-img3-mob_SHCOV1Hrs.jpg?updatedAt=1742461167966) left top / cover no-repeat !important; height: auto !important;}
}

</style>
<style>
u + .body .gmail-blend-screen { background:#000; mix-blend-mode:screen; }
u + .body .gmail-blend-difference { background:#000; mix-blend-mode:difference; }
</style>
<style>
/*	Darkmode code for the IOS start*/
@media (prefers-color-scheme: dark ) {
.mainbg { background-color: #000 !important; }
.darkmode { background-color: #272623 !important; }
h1, h2, p, span, a, b, ul, li, ol { color: #ffffff !important; }
.darktext h1, .darktext h2, .darktext p, .darktext span { color: #000 !important; }
.textBlue {color: #223c83 !important;}
.textBlack {color: #000000 !important;}
.textwhite {color: #ffffff !important;}

/* OUTLOOK APP (ANDROID) DARK MODE STYLES */
[data-ogsc] .mainbg { background-color: #000 !important; }
[data-ogsc] .darkmode { background-color: #272623 !important; }
[data-ogsc] h1, [data-ogsc] h2, [data-ogsc] p, [data-ogsc] span, [data-ogsc]  span, [data-ogsc] a, [data-ogsc] b, [data-ogsc] ul, [data-ogsc] li, [data-ogsc] ol { color: #ffffff !important; }
[data-ogsc] .darktext h1, [data-ogsc] .darktext h2, [data-ogsc] .darktext p, [data-ogsc] .darktext span, .darktext li{ color: #000000 !important; }
[data-ogsc].textBlue {color: #223c83 !important;}
[data-ogsc].textBlack {color: #000000 !important;}
[data-ogsc].textwhite {color: #ffffff !important;}
}
/*	Darkmode code for the IOS end*/
</style>

</head>
<body class="body mainbg" style="margin: 0; padding: 0; background-color: #ffffff;">
<div id="preheader" style="display: none; font-size: 0; line-height: 0; mso-hide: all; color: #e3e3e3;">Preheader Text</div>
<div id="preview-spacer" style="display: none; font-size: 0; line-height: 0; mso-hide: all; color: #e3e3e3;">&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;</div>
<div role="article" aria-roledescription="email" aria-label="email name" lang="en" dir="ltr" style="font-size:16px; font-size:1rem; font-size:max(16px, 1rem)">
<table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" class="mainbg">
<tr>
<td align="center">
<table width="640" border="0" cellspacing="0" cellpadding="0" style="width: 640px; max-width: 640px" class="w320 darkmode">
<tbody>
<tr><td align="center"><table width="100%" border="0" cellspacing="0" cellpadding="0" align="center">
<tbody>
<!--  Top Section Start  -->
<tr>
<td align="center" style="padding-bottom: 15px;"><table width="50%" border="0" cellspacing="0" cellpadding="0" align="center" class="w90">
<tbody>
<tr>
<td style="font-family: Arial; color: #828282; font-size: 13px; font-weight: normal; line-height: 18px; text-align: center; padding-top: 30px; padding-bottom: 10px; border-bottom: 2px solid #A9A9A9;" class="font12">Click <a href="https://srihari.site/" target="_blank" class="font12" title="here" style="color:#828282; text-decoration: underline;">here</a> to view email in Browser</td>
</tr>
</tbody>
</table>
</td>
</tr>
<!--  Top Section End  -->

<!--  Logo Section Start  -->
<tr>
<td bgcolor="#000000" valign="top" align="center" background="https://ik.imagekit.io/sriHari143/templates/n1/bg-img1-desk_5XOxLDUId.jpg?updatedAt=1742461173173" style="background-size: 640px 53px; background-position: top center; background-repeat: no-repeat; height: 53px;" class="bg_img1">
<!--[if gte mso 9]> 
<v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="width:640px; height:53px; background-size:640px 53px; background-position: top center; background-repeat: no-repeat;">
<v:fill type="frame" src="https://ik.imagekit.io/sriHari143/templates/n1/bg-img1-desk_5XOxLDUId.jpg?updatedAt=1742461173173" color="#000000" />
<v:textbox inset="0,0,0,0">
<![endif]--> 
<div style="margin: 0; vertical-align: top;">  
<table align="center" width="88%" border="0" cellspacing="0" cellpadding="0" style="width: 88%;" class="w290" role="presentation">
<tbody>
<tr>
<td valign="top" align="center" height="5" style="height: 5px;">
</td>
</tr>
<tr><td>
<table width="100%" style="width: 100%;" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr>
<td align="left" valign="top" width="41" style="width: 41px;"><a href="https://srihari.site/" target="_blank" style="text-decoration: none;" title="LOGO"><img src="https://ik.imagekit.io/sriHari143/templates/n1/logo_FGWqTh2lNu.png?updatedAt=1742461168130" style="width: 41px; height: 41px; margin: 0px 0px 0px 0px;" width="41" height="41" alt="LOGO" align="left"></a></td>
<td align="center" style="font-family: Arial; color: #ffffff; font-size: 15px; line-height: 20px; mso-color-alt: auto; text-align: center;" class="font12 textwhite">Hello John, Welcome to our email program!</td>
</tr>
</tbody>
</table>
</td></tr>
<tr>
<td valign="top" align="center" height="5" style="height: 5px;">
</td>
</tr>
</tbody>
</table>
</div>  
<!--[if gte mso 9]>
</v:textbox>
</v:rect>
<![endif]-->
</td>
</tr>
<!--  Logo Section End  -->

<!--  Banner Section Start  -->  
<tr>
<td align="left" valign="top" style="padding-top: 15px;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/banner-desk_6c4BtYOSc.jpg?updatedAt=1742461172874" alt="" width="640" height="160" style="display: block; border: 0; width: 640px; max-width: 640px; height: 160px;" border="0" class="mobile-hide"/><!--[if mso]><!--><div style="display: none; mso-hide: all;" class="mobile-show"><img src="https://ik.imagekit.io/sriHari143/templates/n1/banner-mob_EQ0BVzu7a.jpg?updatedAt=1742461173037" alt="" width="1" height="1" style="display: block; border: 0; width: 100%; height: auto;" class="w100"/></div><!--<![endif]--></td>    
</tr>
<!--  Banner Section End  --> 

<!--  Two CTA's Section Start  -->  
<tr><td align="center" style="padding-bottom: 30px;">
<table width="82%" border="0" cellspacing="0" cellpadding="0" style="width: 82%;" align="center" class="w80" role="presentation">
<tbody>
<tr>
<td align="center" style="font-family: Arial; color: #000000; font-size: 15px; line-height: 20px; text-align: center; padding: 20px 0px;" class="textwhite">Choose how you want to hear about us.</td>
</tr>
<tr><td>
<table width="100%" style="width: 100%;" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr>
<td style="background-color: #000000; width: 48%;" width="48%" class="drop"><a href="https://srihari.site/" target="_blank">
<table width="100%" style="width: 100%;" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr>
<td height="15" style="height: 15px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
<tr>
<td style="font-family: Arial; color: #ffffff; font-size: 19px; line-height: 19px; text-align: center;">SMS</td>
</tr>
<tr>
<td height="15" style="height: 15px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
</tbody>
</table>
</a></td>
<td style="width: 4%; height: 20px;" width="4%" height="20" class="drop">&nbsp;</td>
<td style="background-color: #000000; width: 48%;" width="48%" class="drop"><a href="https://srihari.site/" target="_blank">
<table width="100%" style="width: 100%;" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr>
<td height="15" style="height: 15px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
<tr>
<td style="font-family: Arial; color: #ffffff; font-size: 19px; line-height: 19px; text-align: center;">EMAIL</td>
</tr>
<tr>
<td height="15" style="height: 15px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
</tbody>
</table>
</a></td>
</tr>
</tbody>
</table>
</td></tr>
</tbody>
</table>
</td></tr>
<!--  Two CTA's Section End  --> 

<!--  Card Section's Start  --> 
<tr><td align="center">
<table width="88%" border="0" cellspacing="0" cellpadding="0" align="center" style="width: 88%;" class="w80" role="presentation">
<tbody>
<tr>
<td height="190" valign="top" width="50%" style="width: 50%; background-color: #000000; padding: 0px 0px 0px 0px; height: 190px;" align="center" class="display-footer">
<table width="86%" style="width: 86%;" border="0" cellspacing="0" cellpadding="0" align="center" role="presentation">
<tbody>
<tr>
<td style="font-family: Arial; color: #ffffff; font-size: 9px; line-height: 14px; text-align: left; padding-bottom: 15px; padding-top: 10px;">Text 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</td>
</tr>
<tr><td class="pb20">
<a href="https://srihari.site/" target="_blank" style="background-color: #ffffff;">
<table width="60%" border="0" cellspacing="0" cellpadding="0" style="background-color: #ffffff; width: 60%;" role="presentation">
<tbody>
<tr>
<td height="12" style="height: 12px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
<tr>
<td style="font-family: Arial; color: #000000; font-size: 10px; line-height: 10px; text-align: center;">Learn more</td>
</tr>
<tr>
<td height="12" style="height: 12px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
</tbody>
</table>
</a>
</td></tr>
</tbody>
</table>
</td>
<td height="190" width="50%" style="background-color: #000000; width: 50%; height: 190px;" class="display-header"><img src="https://ik.imagekit.io/sriHari143/templates/n1/card1_uqBVBp4Ai.jpg?updatedAt=1742461168162" alt="Learn more" width="100%" height="190" style="display: block; border: 0; width: 100%; height: 190px;" border="0" class="mobile-hide"/><!--[if mso]><!--><div style="display: none; mso-hide: all;" class="mobile-show"><img src="https://ik.imagekit.io/sriHari143/templates/n1/card1_uqBVBp4Ai.jpg?updatedAt=1742461168162" alt="Learn more" width="1" height="1" style="display: block; border: 0; width: 100%; height: auto;" class="w100"/></div><!--<![endif]--></td>
</tr>
<tr>
<td height="190" width="50%" style="width: 50%; background-color: #000000; height: 190px;" class="drop"><img src="https://ik.imagekit.io/sriHari143/templates/n1/card2_ScHbJl_Bf.jpg?updatedAt=1742461167858" alt="See more" width="100%" height="190" style="display: block; border: 0; width: 100%; height: 190px;" border="0" class="mobile-hide"/><!--[if mso]><!--><div style="display: none; mso-hide: all;" class="mobile-show"><img src="https://ik.imagekit.io/sriHari143/templates/n1/card2_ScHbJl_Bf.jpg?updatedAt=1742461167858" alt="See more" width="1" height="1" style="display: block; border: 0; width: 100%; height: auto;" class="w100"/></div><!--<![endif]--></td>
<td height="190" valign="top" width="50%" style="width: 50%; background-color: #000000; padding: 0px 0px 0px 0px;" align="center" class="drop">
<table width="86%" style="width: 86%;" border="0" cellspacing="0" cellpadding="0" align="center" role="presentation">
<tbody>
<tr>
<td style="font-family: Arial; color: #ffffff; font-size: 9px; line-height: 14px; text-align: left; padding-bottom: 15px; padding-top: 10px;">Text 2 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</td>
</tr>
<tr><td class="pb20">
<a href="https://srihari.site/" target="_blank" style="background-color: #ffffff;">
<table width="60%" border="0" cellspacing="0" cellpadding="0" style="background-color: #ffffff; width: 60%;" role="presentation">
<tbody>
<tr>
<td height="12" style="height: 12px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
<tr>
<td style="font-family: Arial; color: #000000; font-size: 10px; line-height: 10px; text-align: center;">See more</td>
</tr>
<tr>
<td height="12" style="height: 12px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
</tbody>
</table>
</a>
</td></tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td></tr>
<!--  Card Section's Section End  -->

<!--  Man Section Start  -->
<tr><td style="height: 20px;" class="pt55"></td></tr>
<tr>
<td valign="top" align="center" background="https://ik.imagekit.io/sriHari143/templates/n1/bg-img2-desk_eRkpPGmaq.png?updatedAt=1742461175422" bgcolor="#ffffff" style="background-size: 640px 216px; background-position: top center; background-repeat: no-repeat; height: 216px;" class="bg_img2 darkmode">
<!--[if gte mso 9]> 
<v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="width:640px; height:216px; background-size:640px 216px; background-position: top center; background-repeat: no-repeat;">
<v:fill type="frame" src="https://ik.imagekit.io/sriHari143/templates/n1/bg-img2-desk_eRkpPGmaq.png?updatedAt=1742461175422" color="none" />
<v:textbox inset="0,0,0,0">
<![endif]--> 
<div style="margin: 0; vertical-align: top;" class="">  
<table align="center" width="88%" border="0" cellspacing="0" cellpadding="0" style="width: 88%;" class="w290" role="presentation">
<tbody>
<tr>
<td valign="top" align="left" width="80%" style="width: 80%;" class="display-footer">
<table width="100%" style="width: 100%;" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr>
<td style="border-bottom: 2px solid #828282; padding-bottom: 5px;"><p style="margin: 0px; font-family: Arial; color: #000000; font-size: 21px; line-height: 26px; text-align: left; margin-top: 20px;">Exciting content <span style="font-weight:bold;">EVERY DAY!</span></p></td>
</tr>
<tr><td style="padding-top: 35px;" class="pt35">
<table width="62%" border="0" cellspacing="0" cellpadding="0" style="width: 62%;" class="w100" role="presentation">
<tbody>
<tr>
<td style="font-family: Arial; color: #ffffff; font-size: 9px; line-height: 14px; text-align: left; mso-color-alt: auto; padding-bottom: 15px" class="pb25 textCenter"><div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="font-family: Arial; color: #ffffff; font-size: 9px; line-height: 14px; text-align: left; margin: 0px;">Text 3 Lorem ipsum dolor sit amet, consectetur adipiscing elit, se do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut&nbsp;enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p></div></div></td>
</tr>
<tr><td class="pb25">
<table width="60%" border="0" cellspacing="0" cellpadding="0" style="width: 60%;" class="w100" role="presentation">
<tbody>
<tr>
<td><a href="https://srihari.site/" target="_blank" style="background-color: #ffffff;" class="textCenter" >
<table width="100%" border="0" cellspacing="0" cellpadding="0" style="background-color: #ffffff; width: 100%;" align="center" class="w60" role="presentation">
<tbody>
<tr>
<td height="10" style="height: 10px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
<tr>
<td style="font-family: Arial; color: #000000; font-size: 10px; line-height: 10px; text-align: center;">Learn more</td>
</tr>
<tr>
<td height="10" style="height: 10px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
</tbody>
</table>
</a></td>
</tr>
</tbody>
</table>
</td></tr>
</tbody>
</table>
</td></tr>
</tbody>
</table>
</td>
<td align="center" valign="top" style="padding-top: 15px" class="display-header"><img src="https://ik.imagekit.io/sriHari143/templates/n1/man_B_JsZ4FRJ.png?updatedAt=1742461171916" alt="Learn more" width="52" height="192" style="display: block; border: 0; width: 52px; height: 192px;" border="0" class="hide"/></td>
</tr>
</tbody>
</table>
</div>  
<!--[if gte mso 9]>
</v:textbox>
</v:rect>
<![endif]-->
</td>
</tr>
<!--  Man Section End  -->

<!--  Camera Section Start  -->
<tr><td style="height: 20px;" class="pt30"></td></tr>
<tr>
<td valign="top" align="center" background="https://ik.imagekit.io/sriHari143/templates/n1/bg-img3-desk_OrhnO9Gh6.png?updatedAt=1742461176837" bgcolor="#ffffff" style="background-size: 640px 321px; background-position: top center; background-repeat: no-repeat; height: 321px;" class="bg_img3 darkmode">
<!--[if gte mso 9]> 
<v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="width:640px; height:321px; background-size:640px 321px; background-position: top center; background-repeat: no-repeat;">
<v:fill type="frame" src="https://ik.imagekit.io/sriHari143/templates/n1/bg-img3-desk_OrhnO9Gh6.png?updatedAt=1742461176837" color="#000000" />
<v:textbox inset="0,0,0,0">
<![endif]--> 
<div style="margin: 0; vertical-align: top;" class="" >  
<table align="center" width="88%" border="0" cellspacing="0" cellpadding="0" style="width: 88%;" class="w290" role="presentation">
<tbody>
<tr>
<td valign="top" align="center" style="padding: 200px 0px 20px 0px;" >
<table width="80%" border="0" cellspacing="0" cellpadding="0" align="center" style="width: 80%;" role="presentation">
<tbody>
<tr>
<td>
<table width="100%" style="width: 100%;" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr><td>
<table width="100%" style="width: 100%;" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr>
<td width="50%" style="width: 50%;" class="drop">
<table width="100%" style="width: 100%;" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr>
<td width="25%" style="width: 25%;" align="center">
<p style="margin: 0px;"><a href="https://srihari.site/" target="_blank" title="100,000 flowers" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/sm-card1_Vj5UqqQgq.png?updatedAt=1742461171764" alt="100,000 flowers" width="60" height="60" style="display: block; border: 0; width: 60px; height: 60px;" border="0" /></a></p>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 6px 0px 0px 0px; font-family: Arial; color: #ffffff; font-size: 11px; line-height: 16px; text-align: center; font-weight: bold; mso-color-alt: auto;"><a href="https://srihari.site/" target="_blank" title="100,000" style="text-decoration: none;">100,000</a></p></div></div>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 0px 0px 0px 0px; font-family: Arial; color: #ffffff; font-size: 9px; line-height: 14px; text-align: center; mso-color-alt: auto;"><a href="https://srihari.site/" target="_blank" title="flowers" style="text-decoration: none;">flowers</a></p></div></div>
</td>
<td width="25%" style="width: 25%;" align="center">
<p style="margin: 0px;"><a href="https://srihari.site/" target="_blank" title="4 Hours battery" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/sm-card2_hnkvb0nzIO.png?updatedAt=1742461172285" alt="4 Hours battery" width="60" height="60" style="display: block; border: 0; width: 60px; height: 60px;" border="0" /></a></p>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 6px 0px 0px 0px; font-family: Arial; color: #ffffff; font-size: 11px; line-height: 16px; text-align: center; font-weight: bold; mso-color-alt: auto;"><a href="https://srihari.site/" target="_blank" title="4 Hours" style="text-decoration: none;">4 Hours</a></p></div></div>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 0px 0px 0px 0px; font-family: Arial; color: #ffffff; font-size: 9px; line-height: 14px; text-align: center; mso-color-alt: auto;"><a href="https://srihari.site/" target="_blank" title="battery" style="text-decoration: none;">battery</a></p></div></div>
</td>
</tr>
</tbody>
</table>
</td>
<td width="50%" style="width: 50%;" class="drop pt20">
<table width="100%" style="width: 100%;" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr>
<td width="25%" style="width: 25%;" align="center">
<p style="margin: 0px;"><a href="https://srihari.site/" target="_blank" title="Auto shuttle" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/sm-card3_OLyPCG1pH.png?updatedAt=1742461172007" alt="Auto shuttle" width="60" height="60" style="display: block; border: 0; width: 60px; height: 60px;" border="0" /></a></p>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 6px 0px 0px 0px; font-family: Arial; color: #ffffff; font-size: 11px; line-height: 16px; text-align: center; mso-color-alt: auto; font-weight: bold;"><a href="https://srihari.site/" target="_blank" title="Auto" style="text-decoration: none;">Auto</a></p></div></div>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 0px 0px 0px 0px; font-family: Arial; color: #ffffff; font-size: 9px; line-height: 14px; text-align: center; mso-color-alt: auto;"><a href="https://srihari.site/" target="_blank" title="shuttle" style="text-decoration: none;">shuttle</a></p></div></div>
</td>
<td width="25%" style="width: 25%;" align="center">
<p style="margin: 0px;"><a href="https://srihari.site/" target="_blank" title="15,025 brightness" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/sm-card4_zGjMtyEs4j.png?updatedAt=1742461172346" alt="15,025 brightness" width="60" height="60" style="display: block; border: 0; width: 60px; height: 60px;" border="0" /></a></p>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 6px 0px 0px 0px; font-family: Arial; color: #ffffff; font-size: 11px; line-height: 16px; text-align: center; font-weight: bold; mso-color-alt: auto;"><a href="https://srihari.site/" target="_blank" title="15,025" style="text-decoration: none;">15,025</a></p></div></div>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 0px 0px 0px 0px; font-family: Arial; color: #ffffff; font-size: 9px; line-height: 14px; text-align: center; mso-color-alt: auto;"><a href="https://srihari.site/" target="_blank" title="brightness" style="text-decoration: none;">brightness</a></p></div></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td></tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>  
<!--[if gte mso 9]>
</v:textbox>
</v:rect>
<![endif]-->
</td>
</tr>
<!--  Camera Section End  --> 

<!--  Footer Section Start  --> 	  
<tr>
<td align="center" valign="top" bgcolor="#000000">
<!--[if gte mso 9]>
<v:rect stroke="false" style="width: 640px; height:230px;">
<v:fill opacity="100%" color="#000000"/>
<v:textbox inset="25px,0px,25px,-20px" style="mso-fit-shape-to-text:true;">
<![endif]-->
<div style="margin: 0px; padding: 0px; vertical-align: top; background-image: linear-gradient(#000, #000)" >
<table width="88%" border="0" cellspacing="0" cellpadding="0" style="width:88%;" align="center" class="w80" role="presentation">
<tbody>
<tr><td style="padding: 30px 0px;" align="center">
<table width="100%" border="0" cellspacing="0" cellpadding="0" style="width: 100%;" class="w284" align="center" role="presentation">
<tbody>
<tr>
<td valign="middle"><div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 16px; color: #ffffff; font-weight: normal; mso-color-alt: auto; margin-bottom: 15px;">Camera  &nbsp;&bull;&nbsp;  Digital single-lens reflex  <span class="mobile-hide">&nbsp;&bull;&nbsp;</span>  <br style="display: none;" class="mobile-show">LENS  &nbsp;&bull;&nbsp;  BAG </p></div></div>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 16px; color: #ffffff; font-weight: normal; mso-color-alt: auto; margin-bottom: 15px;">&copy; Copyright 2003-2021 Company Name to display here. All Rights Reserved.</p></div></div>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 16px; color: #ffffff; font-weight: normal; mso-color-alt: auto; margin-bottom: 15px;">Text for desktop only. You are receiving this email because you participated in a previous offer and opted in for follow-up communication. This is from Company Name to display here, the company&#39;s address and the city, in what state is the company, and it&#39;s postal code. Some random Desk text.</p></div></div>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 16px; color: #ffffff; font-weight: normal; mso-color-alt: auto; margin-bottom: 25px;">Please add <a href="mailto:info@companyname.com" target="_blank" title="info@companyname.com" style="color: #ffffff !important;">info@companyname.com</a> to your address book to ensure our emails reach your inbox.</p></div></div>
</td>
</tr>
<tr>
<td valign="middle">
<table width="220" border="0" cellspacing="0" cellpadding="0" style="width: 220px;"  role="presentation">
<tbody>
<tr>
<td width="25%" style="width: 25%"><a href="https://srihari.site/" target="_blank" title="Instagram" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/instagram_EhP7zpJBhJ.png?updatedAt=1742461168041" alt="Instagram" width="27" height="auto" style="display: block; border: 0; width: 27px; height: auto" border="0"/></a></td>
<td width="25%" style="width: 25%"><a href="https://srihari.site/" target="_blank" title="Youtube" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/youtube_WzCczoRJKg.png?updatedAt=1742461172571" alt="Youtube" width="31" height="auto" style="display: block; border: 0; width: 31px; height: auto" border="0"/></a></td>
<td width="25%" style="width: 25%"><a href="https://srihari.site/" target="_blank" title="Twitter" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/twitter_1EQ8iSNHfQ.png?updatedAt=1742461172449" alt="Twitter" width="27" height="auto" style="display: block; border: 0; width: 27px; height: auto" border="0"/></a></td>
<td width="25%" style="width: 25%"><a href="https://srihari.site/" target="_blank" title="Facebook" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/facebook_ISccCiYlks.png?updatedAt=1742461168044" alt="Facebook" width="15" height="auto" style="display: block; border: 0; width: 15px; height: auto" border="0"/></a></td>
</tr>
</tbody>
</table></td>	  
</tr>
</tbody>
</table>
</td></tr>
</tbody>
</table>
</div>
<!--[if gte mso 9]> 
</v:textbox>
</v:fill>
</v:rect>
<![endif]-->
</td>	
</tr>
<!--  Footer Section End  --> 

<!--  Bottom Footer Section Start  --> 
<tr><td style="background-color: #789db4; padding: 20px 0px;" align="center">
<table width="88%" border="0" cellspacing="0" cellpadding="0" style="width: 88%;" align="center" class="w80" role="presentation">
<tbody>
<tr>
<td>
<table width="100%" style="width: 100%;" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr>
<td align="left" valign="top" width="10%" style="width: 10%;" class="drop"><a href="https://srihari.site/" target="_blank" style="text-decoration: none;" title="LOGO"><img src="https://ik.imagekit.io/sriHari143/templates/n1/logo_FGWqTh2lNu.png?updatedAt=1742461168130" style="width: 41px; height: 41px; margin: 0px 0px 0px 0px;" width="41" height="41" alt="LOGO" align="left"></a></td>
<td class="drop" style="height: 20px;"></td>
<td align="left" class="drop" width="40%" style="width: 40%;">  
<table width="100%" border="0" cellspacing="0" cellpadding="0" style="width: 100%;" align="left" class="w75" role="presentation">
<tbody>
<tr>
<td width="30" style="width: 30px;" align="right"><a href="https://srihari.site/" target="_blank" title="Footer-Icon" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/footer-icon1_2qX0MXk50E.png?updatedAt=1742461167974" alt="Footer-Icon" width="30" height="auto" style="display: block; border: 0; width: 30px; height: auto" border="0"/></a></td>
<td width="30" style="width: 30px;"></td>
<td width="32" style="width: 32px;" align="right"><a href="https://srihari.site/" target="_blank" title="Footer-Icon" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/footer-icon2_wKNODxB36d.png?updatedAt=1742461168159" alt="Footer-Icon" width="32" height="auto" style="display: block; border: 0; width: 32px; height: auto" border="0"/></a></td>
<td width="30" style="width: 30px;"></td>
<td width="27" style="width: 27px;" align="right"><a href="https://srihari.site/" target="_blank" title="Footer-Icon" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/footer-icon3_iN0mna4tSm.png?updatedAt=1742461168054" alt="Footer-Icon" width="27" height="auto" style="display: block; border: 0; width: 27px; height: auto" border="0"/></a></td>
<td width="30" style="width: 30px;"></td>
<td width="34" style="width: 34px;" align="right"><a href="https://srihari.site/" target="_blank" title="Footer-Icon" style="text-decoration: none;"><img src="https://ik.imagekit.io/sriHari143/templates/n1/footer-icon4___rbnHzqY0.png?updatedAt=1742461168156" alt="Footer-Icon" width="34" height="auto" style="display: block; border: 0; width: 34px; height: auto" border="0"/></a></td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr><td>
<div class="gmail-blend-screen "><div class="gmail-blend-difference"><p style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 16px; color: #ffffff; font-weight: normal; mso-color-alt: auto; margin-top: 20px;" class="pb15"><a href="https://srihari.site/" target="_blank" style="text-decoration: none;" title="Unsubscribe">Unsubscribe</a> &nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;&nbsp; <a href="https://srihari.site/" target="_blank" style="text-decoration: none;" title="Privacy policy">Privacy policy</a> &nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;&nbsp; <br style="display: none;" class="mobile-show"> <a href="https://srihari.site/" target="_blank" style="text-decoration: none;" title="Terms &amp; conditions">Terms &amp; conditions</a> &nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;&nbsp; <a href="https://srihari.site/" target="_blank" style="text-decoration: none;" title="Contact">Contact</a></p></div></div>
<div class="gmail-blend-screen"><div class="gmail-blend-difference"><p style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 16px; color: #ffffff; font-weight: normal; mso-color-alt: auto; margin-top: 4px;">&copy; Copyright 2003-2021 Company Name to display here. All Rights Reserved.</p></div></div>
</td></tr>
</tbody>
</table>
</td></tr>
<!--  Bottom Footer Section End  --> 
</tbody>
</table>
</td></tr>
</tbody>
</table>
</td>
</tr>
</table>
</div>
</body>
</html>
`;